import React, { useMemo } from "react";
import { Label } from "reactstrap";
import BulkNotificationFillControldocFormDocumentList from "../../../../bulk/notification/fill/controldoc_form_document_list";
import { fetchCustomFieldValue } from "../../../../helper/custom_field/helper"

const LaboralBulkNotificationFillForm = props => {

  const {
    currentCustomer,
    currentUser,
    securityLayers,
    data: {
      companies,
      documentTypes,
      customFields
    }
  } = props;

  const documentTypeOptions = _.sortBy(_.uniqBy(_.map(documentTypes, dt => dt), "id"));
  const defaultRequestParams = { "filterrific": { "by_aasm_state": "pending" } };

  const dataTableSecurityLayerColumns = useMemo(() => {
    if (currentCustomer.security_layer && securityLayers?.length > 0) {
      return {
        field: 'document.entity.employee.security_layer.name',
        header: I18n.t("activerecord.attributes.laboral/employee.security_layer_id"),
        body: (row) => row?.document?.entity?.employee?.security_layer?.name || I18n.t('no_entry'),
      }
    }
  }, [currentCustomer.security_layer, securityLayers]);

  const dataTableDefaultColumns = [
    {
      field: 'document.entity.company.name',
      header: I18n.t("activerecord.attributes.laboral/hiring.company"),
      filter: {
        enabled: true,
        placeholder: 'Seleccione una empresa',
        inputType: 'simple_select',
        filterrific: {
          search: 'by_company',
        },
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name,
        })),
      }
    },
    {
      field: 'email',
      header: I18n.t("activerecord.attributes.laboral/employee.email"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el correo electrónico del empleado',
        filterrific: {
          search: 'search_by_email'
        }
      }
    },
    {
      field: "name",
      header: `${I18n.t("activerecord.attributes.controldoc_form/template.name")} formulario`,
      body: (row) => row.name || I18n.t("no_entry"),
      filter: {
        enabled: true,
        placeholder: `Ingrese un ${I18n.t("activerecord.attributes.controldoc_form/template.name")}`,
        filterrific: {
          search: "search_by_name"
        }
      }
    },
    {
      field: "document.entity.employee.name",
      header: I18n.t("activerecord.attributes.laboral/employee.name"),
      filter: {
        enabled: true,
        placeholder: `Ingrese el nombre del ${I18n.t("activerecord.attributes.laboral/employee")}`,
        filterrific: {
          search: "search_by_employee_name"
        }
      }
    },
    {
      field: "document.entity.identifier",
      header: I18n.t("activerecord.attributes.laboral/hiring.identifier"),
      filter: {
        enabled: true,
        placeholder: `Ingrese el identificador de la ${I18n.t("activerecord.attributes.laboral/hiring")}`,
        filterrific: {
          search: "search_by_hiring_identifier"
        }
      }
    },
    {
      field: "document.entity.active_to_s",
      header: `Estado de Contratación`,
      filter: {
        enabled: true,
        placeholder: `Seleccione un estado de contratación`,
        inputType: 'simple_select',
        options: [
          { value: 'active', label: "Activo" },
          { value: 'expired', label: "Inactivo" },
        ],
        filterrific: {
          search: "by_hiring_state"
        }
      }
    },
    {
      field: "document.entity.start_date_to_s",
      header: `${I18n.t("activerecord.attributes.laboral/hiring.start_date")}`,
      filter: {
        enabled: true,
        placeholder: `Ingrese el ${I18n.t("activerecord.attributes.laboral/hiring.start_date")}`,
        filterrific: {
          search: "search_by_hiring_start_date"
        }
      }
    },
    {
      field: "document.entity.end_date_to_s",
      header: `${I18n.t("activerecord.attributes.laboral/hiring.end_date")}`,
      filter: {
        enabled: true,
        placeholder: `Ingrese el ${I18n.t("activerecord.attributes.laboral/hiring.end_date")}`,
        filterrific: {
          search: "search_by_hiring_end_date"
        }
      }
    },
    {
      field: "document.label",
      header: I18n.t("activerecord.attributes.document.label"),
      filter: {
        enabled: true,
        placeholder: `Ingrese el ${I18n.t("activerecord.attributes.document.label")}`,
        filterrific: {
          search: "search_by_document_name"
        }
      }
    },
    {
      field: "document.document_type.name",
      header: I18n.t("activerecord.attributes.document.document_type"),
      filter: {
        enabled: true,
        placeholder: `Seleccione un ${I18n.t("activerecord.attributes.document.document_type")}`,
        inputType: 'simple_select',
        options: _.map(documentTypeOptions, type => ({
          value: type.id,
          label: type.name,
        })),
        filterrific: {
          search: "by_document_type"
        }
      }
    },
    {
      field: "created_at_to_s",
      header: I18n.t("activerecord.attributes.controldoc_form/document.created_at"),
      filter: {
        enabled: true,
        placeholder: `Ingrese el ${I18n.t("activerecord.attributes.controldoc_form/document.created_at")}`,
        filterrific: {
          search: "search_by_created_at"
        }
      }
    }
  ]

  const dataTableCustomFieldsColumns = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `document.entity.custom_fields.${customField.code}`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.document.entity.custom_fields[customField.code], currentUser)
        },
        filter: {
          enabled: true,
          placeholder: `Ingrese ${_.capitalize(customField.label)}`,
          filterrific: {
            search: `search_by_key_custom_fields`,
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [customFields])

  const dataTableColumns = useMemo(() => {
    let columns = _.concat(
      dataTableSecurityLayerColumns,
      dataTableDefaultColumns,
      dataTableCustomFieldsColumns
    )

    return _.compact(columns)
  }, [dataTableSecurityLayerColumns, dataTableDefaultColumns, dataTableCustomFieldsColumns])

  return (
    <div className="row">
      <div className="col-12">
        <Label className="d-flex justify-content-center h5 my-4">
          Lista de formularios pendientes por completar
        </Label>
        <BulkNotificationFillControldocFormDocumentList
          dataTableConfiguration={{
            columns: dataTableColumns
          }}
          configuration={{
            defaultRequestParams: defaultRequestParams
          }}
          actions={{
            indexFormDocumentsPath: Routes.laboral_controldoc_form_documents_path
          }}
        />
      </div>
    </div>
  );
};

export default LaboralBulkNotificationFillForm;
